/* eslint-disable max-len */
import QuackQuestion from 'images/coin-pages/questions/quack.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const quackPage: ICoinPageData = {
  title: 'coin_792',
  description: 'coin_793',
  // description:
  //   'Get a Rich Quack loan. Receive up to 90% of your QUACK loan collateral in cash or crypto and continue holding. Borrow Rich Quack instantly for an unlimited term and get extra funds in 15 minutes without selling your crypto.',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Rich Quack (QUACK)' }) }} />
  ),
  questionsBlock: {
    image: QuackQuestion,
    questions: [
      {
        title: 'coin_794',
        answer: 'coin_795',
      },
      {
        title: 'coin_796',
        answer: 'coin_797',
      },
      {
        title: 'coin_798',
        answer: 'coin_799',
      },
      {
        title: 'coin_800',
        answer: 'coin_801',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Rich Quack (QUACK)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_802',
        text: ['coin_804'],
      },
      {
        title: 'coin_803',
        text: ['coin_805'],
      },
    ],
    blogCards: [blogCards.borrowLikePro, blogCards.cryptoCrash],
  },
}
